import * as actionTypes from "./action-types";
import { sendPostRequest } from "../../services/FetchService.js";
import * as API_PATHS from "../../constants/FetchApi.js";
import { removeStorage } from "../../services/StorageService";
import * as LOCALSTORAGE from "../../constants/LocalStorage";

export const crisisJoinSimulation = (joinSimulationRequest) => {
  return async function (dispatch) {
    dispatch({ type: actionTypes.CRISIS_JOIN_SIMULATION_START });
    try {
      const response = await sendPostRequest(API_PATHS.CRISIS_JOIN_SIMULATION, joinSimulationRequest);
      if (!response.data.outcome) {
        dispatch({ type: actionTypes.CRISIS_JOIN_SIMULATION_FAIL, payload: response.data.message });
        return;
      }
      removeStorage(LOCALSTORAGE.crisisJoinSimulationId);
      dispatch({ type: actionTypes.CRISIS_JOIN_SIMULATION_SUCCESS, payload: response.data.payload });
    } catch (err) {
      dispatch({ type: actionTypes.CRISIS_JOIN_SIMULATION_FAIL, payload: err });
    }
  };
};
